import { render, staticRenderFns } from "./Statistics.html?vue&type=template&id=caa4f1c6&scoped=true&"
import script from "./Statistics.js?vue&type=script&lang=js&"
export * from "./Statistics.js?vue&type=script&lang=js&"
import style0 from "./Statistics.scss?vue&type=style&index=0&id=caa4f1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa4f1c6",
  null
  
)

export default component.exports